var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useMemo, useState } from 'react';
import { useBoundary } from '~/hooks/useBoundary';
import { addWindowEventListener, removeWindowEventListener, } from '~/utils/windowEventListen';
function CoordinateNumbers(props) {
    var _a = props.unit, unit = _a === void 0 ? 100 : _a;
    var _b = useBoundary(), width = _b.width, height = _b.height;
    var _c = __read(useState({
        pageXOffset: window.pageXOffset,
        pageYOffset: window.pageYOffset,
    }), 2), windowPosition = _c[0], setWindowPosition = _c[1];
    useEffect(function () {
        var handleWindowScroll = function () {
            setWindowPosition({
                pageXOffset: window.pageXOffset,
                pageYOffset: window.pageYOffset,
            });
        };
        addWindowEventListener('scroll', handleWindowScroll);
        return function () {
            removeWindowEventListener('scroll', handleWindowScroll);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                position: 'fixed',
            } }, useMemo(function () {
            return Array.from({ length: Math.ceil(width / unit) }).map(function (_, index) {
                return (React.createElement("div", { key: index, style: {
                        position: 'absolute',
                        transform: "translate(".concat(index * unit -
                            (windowPosition.pageXOffset < 0
                                ? 0
                                : windowPosition.pageXOffset), "px, 0px)"),
                        color: '#999999',
                    } }, index === 0 ? null : index * unit));
            });
        }, [width, windowPosition.pageXOffset, unit])),
        React.createElement("div", { style: {
                position: 'fixed',
            } }, useMemo(function () {
            return Array.from({ length: Math.ceil(height / unit) }).map(function (_, index) {
                return (React.createElement("div", { key: index, style: {
                        position: 'absolute',
                        transform: "translate(0px, ".concat(index * unit -
                            (windowPosition.pageYOffset < 0
                                ? 0
                                : windowPosition.pageYOffset), "px)"),
                        color: '#999999',
                    } }, index === 0 ? null : index * unit));
            });
        }, [height, windowPosition.pageYOffset, unit]))));
}
export { CoordinateNumbers };
